/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Job_MatchingInputs */

const en_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Matching`)
};

const de_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job-Matching`)
};

const fr_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching emploi`)
};

const es_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda de empleo`)
};

const it_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca lavoro`)
};

const nl_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacature-matching`)
};

const pl_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopasowanie ofert`)
};

const fi_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikkahaku`)
};

const da_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job-matching`)
};

const sv_help_job_matching = /** @type {(inputs: Help_Job_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbmatchning`)
};

/**
* | output |
* | --- |
* | "Job Matching" |
*
* @param {Help_Job_MatchingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_job_matching = /** @type {((inputs?: Help_Job_MatchingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Job_MatchingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_job_matching(inputs)
	if (locale === "fr") return fr_help_job_matching(inputs)
	if (locale === "es") return es_help_job_matching(inputs)
	if (locale === "it") return it_help_job_matching(inputs)
	if (locale === "nl") return nl_help_job_matching(inputs)
	if (locale === "pl") return pl_help_job_matching(inputs)
	if (locale === "fi") return fi_help_job_matching(inputs)
	if (locale === "da") return da_help_job_matching(inputs)
	if (locale === "sv") return sv_help_job_matching(inputs)
	return en_help_job_matching(inputs)
});